module.exports = __webpack_public_path__ + "img/hz_17.296e608d.jpg";